import { Injectable } from '@angular/core';
import { ActionCompletion, Actions, ofActionCompleted, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../common/models';
import {
  SapEtaConfigurationListLoad,
  SapEtaConfigurationListInitialState,
  SapEtaConfigurationDelete,
  SapEtaConfigurationCreate,
  SapEtaConfigurationUpdate,
  SapEtaManualPush,
} from './sap-eta-configuration.actions';
import { SapEtaConfigurationState } from './sap-eta-configuration.state';
import { SapEtaItemModel } from './models/sap-eta.model';

@Injectable()
export class SapEtaConfigurationFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(SapEtaConfigurationState.getLoaded);
  items$: Observable<SapEtaItemModel[]> = this.store.select(SapEtaConfigurationState.getItems);

  constructor(private store: Store, private actions: Actions) {}

  loadAll(): void {
    this.store.dispatch(new SapEtaConfigurationListLoad());
  }

  create(body: SapEtaItemModel): Observable<ActionCompletion<unknown, Error>> {
    this.store.dispatch(new SapEtaConfigurationCreate(body));

    return this.actions.pipe(ofActionCompleted(SapEtaConfigurationCreate));
  }

  update(body: SapEtaItemModel): Observable<ActionCompletion<unknown, Error>> {
    this.store.dispatch(new SapEtaConfigurationUpdate(body));

    return this.actions.pipe(ofActionCompleted(SapEtaConfigurationUpdate));
  }

  delete(id: string): Observable<ActionCompletion<unknown, Error>> {
    this.store.dispatch(new SapEtaConfigurationDelete(id));

    return this.actions.pipe(ofActionCompleted(SapEtaConfigurationDelete));
  }

  pushShipments(id: string): Observable<ActionCompletion<unknown, Error>> {
    this.store.dispatch(new SapEtaManualPush(id));

    return this.actions.pipe(ofActionCompleted(SapEtaManualPush));
  }

  setInitialState(): void {
    this.store.dispatch(new SapEtaConfigurationListInitialState());
  }
}
